export default (t) => [
  {
    text: '',
    value: 'select',
    sortable: false,
    width: 40
  },
  {
    text: t('Lot No.'),
    value: 'lot_number',
    sortable: false,
    width: 180
  },
  {
    text: t('Expire'),
    value: 'expiry_date',
    sortable: false,
    width: 100
  },
  {
    text: t('Quantity'),
    value: 'remaining_quantity',
    sortable: false,
    width: 140
  },
  {
    text: '',
    value: 'unit',
    sortable: false,
    width: 30
  },
  {
    text: t('Cost'),
    value: 'cost',
    sortable: false,
    width: 100
  }
];
